/// <reference types="gapi.auth2" />

export interface GoogleSignInRenderOptions {
  width?: number;
  height?: number;
  longtitle?: boolean;
  theme?: string;
  onSuccess?: GoogleSignInCallback;
  onFailure?: GoogleSignInCallback;
  scope?: Array<'profile' | 'email' | 'swg_entitlements' | string>;
}
export interface GoogleSignInCallback {
  (reason?: string): void;
}

export type GoogleUser = Pick<gapi.auth2.GoogleAuth, 'currentUser'>;

/** @hidden */
export interface LegacyGoogleSettings {
  auth2?: typeof gapi.auth2;
  authInstance?: gapi.auth2.GoogleAuth;
  clientId?: string;
  onSuccess?: Function;
  onFailure?: Function;
  useCustomButton?: boolean;
}

/** @hidden */
export function isLegacyGoogleSetting(object: any): object is LegacyGoogleSettings {
  return (<typeof gapi>object).auth2 !== undefined;
}

/** @hidden */
export function isGoogleCredentialResponse(
  object: any
): object is google.accounts.id.CredentialResponse {
  return (<google.accounts.id.CredentialResponse>object).credential !== undefined;
}

/** @hidden */
export interface FacebookLoginResponse {
  authResponse: FacebookAuthResponse;
  status: string;
}

/** @hidden */
export interface FacebookAuthResponse {
  accessToken: string;
  expiresIn: number;
  signedRequest: string;
  userID: string;
}

/** @hidden */
export type FacebookAuthStatus = 'connected' | 'not_authorized' | 'unknown';

export type SocialSignOnProviders = 'facebook' | 'google' | 'apple';

/** @hidden */
export function isFacebookLoginResponse(
  object: FacebookLoginResponse | Error
): object is FacebookLoginResponse {
  return (<FacebookLoginResponse>object).status !== undefined;
}
